// Sintesi e spiegazione di ogni modulo, mostrate al consulente quando sceglie i moduli
// (onboarding e scheda azienda). notYetActive = modulo predisposto ma senza ancora una
// funzione collegata nell'app del cliente.
export const MODULE_DESCRIPTIONS = {
  anagrafiche: {
    summary: "Attrezzature, personale e formazione dell’azienda.",
    details: [
      "Consultare l’elenco delle attrezzature di ogni sede e reparto (frigoriferi, celle, abbattitori…).",
      "Gestire il personale e la relativa formazione.",
    ],
    where: "Gestione › Attrezzature e Gestione › Personale e formazione.",
  },
  temperature: {
    summary: "Registrazione delle temperature e procedura di abbattimento.",
    details: [
      "Registrare le temperature di frigoriferi, celle e banchi secondo le procedure configurate.",
      "Seguire la procedura di abbattimento dei prodotti e consultare l’elenco dei prodotti abbattuti.",
      "Stampare le etichette dei prodotti abbattuti.",
      "Le temperature fuori dai limiti impostati generano una non conformità.",
    ],
    where: "Controlli HACCP › Temperature e Abbattimento; Produzione › Etichette prodotti abbattuti.",
  },
  pulizie: {
    summary: "Registro di pulizie e sanificazioni secondo il piano.",
    details: [
      "Registrare le pulizie e sanificazioni previste per ogni sede o reparto.",
      "Vedere ogni giorno quali pulizie sono ancora da fare nei Controlli di oggi.",
    ],
    where: "Controlli HACCP › Pulizie e sanificazioni.",
  },
  materie_prime: {
    summary: "Anagrafica materie prime, lotti in arrivo e scadenze.",
    details: [
      "Tenere l’anagrafica delle materie prime con allergeni e scheda tecnica per l’etichetta.",
      "Registrare i lotti ricevuti con fornitore, data di ricevimento e scadenza.",
      "Tenere sotto controllo i lotti in scadenza.",
    ],
    where: "Configurazione › Materie prime e Arrivo merci › Carica lotti manuale / Lotti registrati (lista).",
  },
  fornitori: {
    summary: "Elenco dei fornitori con recapiti e partita IVA.",
    details: [
      "Inserire e importare i fornitori dell’azienda.",
      "Collegare i fornitori alle materie prime e ai lotti, per la tracciabilità.",
    ],
    where: "Gestione › Fornitori.",
  },
  non_conformita: {
    summary: "Registro delle non conformità e delle azioni correttive.",
    details: [
      "Raccogliere le non conformità create in automatico (es. temperature fuori limite) o inserite a mano.",
      "Registrare l’azione correttiva e seguirne lo stato fino alla chiusura, con lo storico.",
    ],
    where: "Gestione › Non conformità.",
  },
  ricette: {
    summary: "Ricette con allergeni, produzioni e lotti di produzione.",
    details: [
      "Creare le ricette con ingredienti, procedura e calcolo degli allergeni, con storico delle versioni.",
      "Registrare le produzioni scegliendo i lotti delle materie prime usate: viene generato il lotto di produzione.",
      "Consultare l’elenco delle produzioni create.",
    ],
    where: "Produzione › Ricette, Crea produzione e Produzioni create.",
  },
  etichette: {
    summary: "Stampa delle etichette dei prodotti, con QR di tracciabilità.",
    details: [
      "Stampare le etichette delle produzioni (formati per stampante Brother QL).",
      "Per l’etichetta destinata al consumatore, controllo di conformità prima della stampa e registro delle stampe.",
    ],
    where: "Produzione › Etichette & QR.",
  },
  report_base: {
    summary: "Report e verbali, libro degli ingredienti, stampa QR.",
    details: [
      "Scaricare report e verbali in PDF/Excel dei controlli registrati.",
      "Consultare il libro degli ingredienti delle ricette.",
      "Stampare i QR code dell’azienda.",
    ],
    where: "Documenti › Report e verbali, Libro degli ingredienti, Stampa QR code.",
  },
  foto_allegati: {
    summary: "Fotografie e allegati ai controlli.",
    details: ["Modulo predisposto per allegare foto e documenti alle registrazioni: non ha ancora una funzione attiva nell’app del cliente."],
    notYetActive: true,
  },
  magazzino: {
    summary: "Carico rapido dei lotti da scansione del barcode.",
    details: [
      "Scansionare con la fotocamera (o con uno scanner USB/Bluetooth) il barcode della confezione del fornitore.",
      "Caricare il lotto nelle Materie prime senza riscriverlo: dopo la prima associazione il barcode viene riconosciuto da solo.",
    ],
    where: "Gestione › Magazzino.",
  },
  smart_lotto: {
    summary: "Fotografa le etichette delle merci in ingresso: DF HACCP registra i lotti.",
    details: [
      "Foto a raffica delle etichette, anche senza compilare una scheda dopo ogni foto.",
      "Lettura automatica di barcode e codici GS1/DataMatrix (prodotto, lotto e scadenza quando presenti) e prodotto riconosciuto dalle volte precedenti.",
      "Si completa solo ciò che manca; controllo di accettazione e conferma finale sempre dell'operatore.",
    ],
    where: "Arrivo merci › Carica lotti foto smart.",
  },
  moca: {
    summary: "Imballaggi e materiali a contatto con alimenti: lotti, DDT e certificazioni, come per le materie prime.",
    details: [
      "Registrare le consegne di vaschette, film, sacchetti ecc. con DDT/fattura, lotto e certificazione di qualità del fornitore (caricata una volta per articolo).",
      "Associare il lotto MOCA alle produzioni: in automatico per le ricette con imballaggio abituale, altrimenti l'app lo chiede (si può sempre fare dopo).",
      "Sull'etichetta B2B compaiono tipologia e lotto del MOCA; ricerca rapida lotto MOCA → DDT, certificazione e produzioni.",
      "Pensato per chi confeziona o distribuisce in B2B: chi vende solo in vetrina può lasciarlo spento (la voce di menu non compare).",
    ],
    where: "Produzione › MOCA – imballaggi.",
  },
  qr_code: {
    summary: "QR code delle produzioni da apporre su frigo e celle.",
    details: [
      "Stampare un QR fisso per ricetta e sede, da attaccare su frigoriferi e celle anche in anticipo.",
      "Chi lo scansiona vede l’ultima produzione di quella ricetta, senza ristampare il QR.",
    ],
    where: "Documenti › Stampa QR code › QR code produzioni frigo/celle.",
  },
  notifiche_auto: {
    summary: "Report serale al titolare: reparti completi, registri mancanti, addetti inattivi.",
    details: [
      "Ogni sera alle 20:00 il titolare riceve un report dei registri HACCP previsti nella giornata, come notifica nell’app e via email.",
      "Per ogni sede e reparto indica se tutti i registri sono stati compilati e quali mancano.",
      "Indica quali addetti non hanno registrato nulla dei controlli loro assegnati.",
      "Arriva anche nei giorni in cui è tutto completo, come conferma.",
    ],
    where: "Notifiche dell’app (campanella) ed email del titolare.",
  },
  report_mensili: {
    summary: "Report mensili dei controlli.",
    details: ["Accedere ai report mensili delle registrazioni HACCP."],
    where: "Documenti › Report mensili.",
  },
  produzione_avanzata: {
    summary: "Funzioni avanzate di produzione.",
    details: ["Modulo predisposto per funzioni di produzione aggiuntive: al momento non attiva pagine separate da Ricette e produzioni."],
    notYetActive: true,
  },
  programmazione_produzioni: {
    summary: "Produzioni ricorrenti create in automatico.",
    details: [
      "Programmare le produzioni ripetute di una ricetta: l’app le crea da sola alla data e ora previste.",
      "Sospendere, modificare o eliminare le programmazioni.",
    ],
    where: "Produzione › Programmazione produzioni.",
  },
  shelf_life_expert: {
    summary: "Valutazione guidata della durata dei prodotti (shelf life).",
    details: [
      "Calcolare con un motore a punteggio una durata proposta per il prodotto.",
      "Ottenere la motivazione tecnica e i riferimenti normativi della proposta, da validare a cura del consulente.",
    ],
    where: "DF Food Safety Expert Engine › Shelf life.",
  },
  ordini: {
    summary: "Ordini e acquisti verso i fornitori.",
    details: ["Modulo predisposto: non ha ancora una funzione attiva nell’app del cliente."],
    notYetActive: true,
  },
  vendite: {
    summary: "Vendite, prezzi e IVA.",
    details: ["Modulo predisposto: non ha ancora una funzione attiva nell’app del cliente."],
    notYetActive: true,
  },
  commerciale: {
    summary: "Anagrafiche commerciali di clienti e fornitori.",
    details: ["Modulo predisposto: non ha ancora una funzione attiva nell’app del cliente."],
    notYetActive: true,
  },
  economico: {
    summary: "Movimenti e report economici.",
    details: ["Modulo predisposto: non ha ancora una funzione attiva nell’app del cliente."],
    notYetActive: true,
  },
};
